import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Pressable, Text } from 'react-native-web';

import buttonStyles from './styles';

const propTypes = {
  thin: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  label: PropTypes.string, // default to value if label not specified
  fullWidth: PropTypes.bool,
  circular: PropTypes.bool,
  pressed: PropTypes.bool,
  variant: PropTypes.string,
  onPress: PropTypes.func,
  style: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  textStyle: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
};
const defaultProps = {
  thin: false,
  value: '',
  label: undefined,
  fullWidth: false,
  circular: false,
  pressed: false,
  variant: undefined,
  onPress: undefined,
  style: undefined,
  textStyle: undefined,
};

const Button = ({
  thin,
  value,
  label,
  pressed,
  onPress,
  variant,
  circular,
  fullWidth,
  style,
  textStyle,
}) => {
  const [hovered, setHovered] = useState(false);

  // pressable styles accepts callback
  const pressableStyles = [
    buttonStyles.base.baseStyles,
    ...(variant
      ? [
          buttonStyles[variant].baseStyles,
          ...(hovered ? [buttonStyles[variant].hover] : []),
          ...(pressed ? [buttonStyles[variant].pressed] : []),
        ]
      : [
          ...(hovered ? [buttonStyles.base.hover] : []),
          ...(pressed ? [buttonStyles.base.pressed] : []),
        ]),

    // specific styling
    ...(circular ? [buttonStyles.base.circular] : []),
    ...(thin ? [buttonStyles.base.thin] : []),
    ...(fullWidth ? [buttonStyles.base.full] : []),
    ...(style ? [style] : []),
  ];

  // text doesn't have access to pressed/hovers params
  const textStyles = [
    buttonStyles.base.text,
    ...(variant
      ? [
          buttonStyles[variant].text,
          ...(hovered ? [buttonStyles[variant].textHover] : []),
          ...(pressed ? [buttonStyles[variant].textPressed] : []),
        ]
      : [
          ...(hovered ? [buttonStyles.base.textHover] : []),
          ...(pressed ? [buttonStyles.base.textPressed] : []),
        ]),
    ...(textStyle ? [textStyle] : []),
  ];

  return (
    <Pressable
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={pressableStyles}
      onPress={() => onPress(value)}
    >
      <Text style={textStyles} selectable={false}>
        {label || value}
      </Text>
    </Pressable>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
